import type { ThemeConfig } from "../types";
import { PrismCandylandScene } from "./Scene";

export const prismCandyland: ThemeConfig = {
  id: "prism-candyland",
  name: "Prism Candyland",
  tagline: "Chrome unicorn, glass bank, rainbow gumball stream",
  brandLabel: "Prism Candyland",
  tokens: {
    bg: "#070611",
    bgElevated: "rgba(255, 255, 255, 0.08)",
    bgPanel: "rgba(10, 9, 22, 0.72)",
    bgOverlay: "rgba(7, 6, 17, 0.86)",

    fg: "#f9f7ff",
    fgMuted: "rgba(229, 225, 255, 0.62)",
    fgStrong: "#ffffff",
    fgInverse: "#070611",

    accent: "#ff4fd8",
    accentSoft: "rgba(255, 79, 216, 0.13)",
    accent2: "#75f6ff",
    accent2Soft: "rgba(117, 246, 255, 0.14)",
    accentRainbow:
      "linear-gradient(110deg, #ff4fd8 0%, #ff9d4d 16%, #ffe66d 32%, #95ff8f 48%, #75f6ff 64%, #9f7aff 82%, #ff4fd8 100%)",

    border: "rgba(255, 255, 255, 0.13)",
    borderSoft: "rgba(255, 255, 255, 0.08)",
    borderStrong: "rgba(117, 246, 255, 0.42)",

    positive: "#95ff8f",
    negative: "#ff5c8a",
    warning: "#ffe66d",

    bankPanelBg:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.07) 48%, rgba(117, 246, 255, 0.1) 100%)",
    bankPanelBorder: "rgba(255, 255, 255, 0.24)",
    bankPanelHeading: "#ffffff",

    fontDisplay: "'Space Grotesk', 'Inter Display', 'Inter', system-ui, sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
    fontMono: "'JetBrains Mono', 'DM Mono', ui-monospace, monospace",

    decorationGlow: "0 22px 70px rgba(117, 246, 255, 0.2), 0 0 34px rgba(255, 79, 216, 0.18)"
  },
  assets: {
    mascot: "scene:prism-candyland",
    decorations: [],
    Scene: PrismCandylandScene
  }
};
